import { RadioField } from 'lib/iterable-hook-form';
import { RadioRow, ErrorText, AttributeDetails, ErrorWrapper } from './JourneyConversions.styled';

type AttributionRowProps = {
  name: string;
  isDisabled?: boolean;
  attributionMode: string;
  text: JSX.Element | string;
  error?: string;
};
export const AttributionRow: React.FC<React.PropsWithChildren<AttributionRowProps>> = ({
  name,
  attributionMode,
  isDisabled = false,
  text,
  error,
  children,
}) => {
  return (
    <RadioRow>
      <AttributeDetails>
        <RadioField
          id={`attribute-mode-${attributionMode}`}
          name={name}
          radioKey={attributionMode}
          isDisabled={isDisabled}
        />
        {text}
        {children}
      </AttributeDetails>

      {error && (
        <ErrorWrapper>
          <ErrorText>{error}</ErrorText>
        </ErrorWrapper>
      )}
    </RadioRow>
  );
};
